module.exports = __webpack_public_path__ + "static/media/sh.87ec8893.svg";